module.exports = __webpack_public_path__ + "assets/2160afca36ddc726b1d03732d1b0dcdd.mp3";